export default __webpack_public_path__ + "static/media/FTSE_Rankings_Report_Q2_2020.87985f86.pdf";